// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {PropTypes, Component} from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

// utilities
import _, {get} from 'lodash';
import cx from 'classnames';
import {stringify as queryStringify} from 'querystring';
import isServer from '../../lib/isServer';
import getPosition from '../../lib/getPosition'; // helper function to get top + left pixels
import getTextSize from '../../lib/getTextSize';
import deepUnset from '../../lib/deepUnset';

// components
import Modal from '../../common/components/r_Modal';
import CloseX from '../../common/svgs/CloseX';
import TackIcon from '../../common/svgs/TackIcon';
import FadeOnChange from '../../common/components/c_FadeOnChange';
import FrontView from './f_FrontCard';
import EditView from './c_EditCard';
import AssessmentContainer from '../admin/Applicant/AssessmentsContainer';
import DocumentsView from './c_DocumentsCard';
import Steps from  './Steps/c_Steps';
import Events from  './r_Events';
import SubNav from './Steps/f_SubNav';

import StatusConfirmation from './c_StatusConfirmation';

import * as asyncActionCreators from '../../redux/actionCreators/async';
import * as syncActionCreators from '../../redux/actionCreators/sync';
import { updatePins } from '../../redux/actionCreators/async/employees';

import { APPLICANT_STATUS } from '../../common/enums';

const statusFlagStyles =  {
  padding: '6px 12px',
  letterSpacing: '.5px',
  fontSize: '15px'
};

const memoizeColor = {};

@connect((state, props) => {
  let arrayIndex;
  const searchQuery = state.routing.locationBeforeTransitions.query.search;
  const currentRoute = _.get(state.routing, 'locationBeforeTransitions.pathname', '');
  const applicant = state.admin.applicant;
  const applicantGroupName = _.get(state.admin.applicant, 'profile.statusGroup');

  if(applicant && !memoizeColor[applicant.profile.applicantStatus.name]) {
    memoizeColor[applicant.profile.applicantStatus.name] = _(state.staticData.applicantStatus)
      .filter(status => status.name === applicant.profile.applicantStatus.name)
      .head()
      .color;
  }

  let availabilityDateMoreThan4Months = false;
  let availabilityDate45DaysOrLess = false;
  let availabilityDateBetween45DaysAnd4Months  = false;

  if (applicant && applicant.profile.availabilityDate) {
    const timeDiff = new Date(applicant.profile.availabilityDate).getTime() - new Date().getTime();
    availabilityDateMoreThan4Months = Math.ceil(timeDiff / (1000 * 3600 * 24)) > 120; // 4 Months.
    availabilityDate45DaysOrLess = Math.ceil(timeDiff / (1000 * 3600 * 24)) <= 45; // 45 Days.
    availabilityDateBetween45DaysAnd4Months = !(availabilityDateMoreThan4Months || availabilityDate45DaysOrLess);
  }

  return {
    // grab applicant corresponding to route email
    viewOrder: get(state, 'labels.viewOrder', []),
    applicant,
    availabilityDateMoreThan4Months,
    availabilityDate45DaysOrLess,
    availabilityDateBetween45DaysAnd4Months,
    profile: state.applicantProfile,
    admin: state.admin,
    user: state.user,
    behavioralAnswers: state.behavioralAnswers,
    workObjectives: state.workObjectives,
    workExperiences: state.workExperiences,
    ratings: state.ratings,
    assessments: state.assessments,
    licenses: state.licenses,
    designations: state.designations,
    skills: state.skills,
    applicantGroupName,
    applicantStatus: _.get(applicant, 'profile.applicantStatus.name'),
    navColumnState: props.params.navColumnState,
    arrayIndex,
    statusColor: memoizeColor[_.get(applicant, 'profile.applicantStatus.name')],
    staticData: state.staticData,
    tempState: state.tempState,
    search: searchQuery,
    pins: state.pins,
    route: {
      current: currentRoute,
      params: props.params,
      query: props.location.query
    } // actually being from from react-redux-router to regular props
  };
})
export default class ExpandedCard extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    applicant: PropTypes.object,
    admin: PropTypes.object,
    behavioralAnswers: PropTypes.object,
    workObjectives: PropTypes.object,
    ratings: PropTypes.object,
    assessments: PropTypes.object,
    applicantGroupName: PropTypes.string,
    applicantStatus: PropTypes.string,
    skills: PropTypes.object.isRequired,
    tempState: PropTypes.object.isRequired,
    arrayIndex: PropTypes.number,
    navColumnState: PropTypes.string,
    statusColor: PropTypes.string,
    staticData: PropTypes.object,
    router: PropTypes.object,
    location: PropTypes.object,
    closeModal: PropTypes.func, // comes from modal, includes modal animation,
    viewOrder: PropTypes.array.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    // performance optimization
    this.shouldComponentUpdate = ::PureRenderMixin.shouldComponentUpdate;
    this.setDimensions = ::this.setDimensions;
  }

  state = {
    confirmationOpen: false,
    deleteConfirmationOpen: false,
    newStatus: {},
    oldStatus: {},
    guideOpen: false,
    activeStepIndex: 0,
    activeSubStepIndex: 0,
    offScreen: false, // flag for if current card is on screen
    collapsedStyle: {}, // collapsing anim styling
    expandedStyle: {
      'min-height': 218,
      'min-width': 672,
      width: '70%'
    },
    worksheetStyle: {
      stepsContainer: {
        subnav: {
          marginTop: 10,
          marginBottom: 10,
          height: 55
        },
        steps: {
          height: 294
        }
      },
      alertsContainer: {
        height: 700,
        width: '100%',
        marginLeft: 0
      },
      cardTranslateX: 0,
      cardTranslateY: 0,
      worksheetTranslateY: 0,
      worksheetScaleX: 0,
      worksheetScaleY: 0,
      closeTranslateX: 0,
      detailToggleTranslateY: 0
    } // expanded worksheet style
  }

  componentWillMount() {
    if(this.props.params.email) {
      this.setDimensions();
      this.props.dispatch(asyncActionCreators.retrieve(this.props.params.email));
      this.props.dispatch(asyncActionCreators.getProfileById(this.props.params.email));
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.setDimensions);
  }

  componentWillReceiveProps(nextProps) {
    if(!this.props.applicant && nextProps.applicant) {
      this.props.dispatch(asyncActionCreators.getProfileById(nextProps.applicant.profile.id));
      this.setDimensions();
    }
  }

  componentDidUpdate(prevProps) {
    if(!prevProps.applicantStatus) {
      return;
    }
    if(this.props.applicantStatus !== prevProps.applicantStatus) { // if status changes, update dimensions
      this.setDimensions();
    }
  }

  componentWillUnmount() {
    this.props.dispatch(syncActionCreators.clearApplicant());
    window.removeEventListener('resize', this.setDimensions);
  }

  onClose() {
    this.props.dispatch(push(`/admin/${this.props.route.params.navColumnState}/${queryStringify(_.omit(this.props.route.query, ['edit', 'detail']))}`));
  }

  onChangeStep(index, url) {
    this.setState(prevState => {
      const newState = _.cloneDeep(prevState);
      newState.activeStepIndex = index;
      return _.merge({}, this.state, newState);
    }, () => {
      if (url) {
        this.props.dispatch(push(url));
      }
    });
  }

  // handles tempState updates
  onStatusChange(property, event, value, name) {
    if (value === _.get(this.props.applicant.profile, 'applicantStatus.id', null)) {
      return;
    }
    // handle dropdown
    if(name) {
      value = {
        id: value,
        name
      };
    }

    // Confirm popup for qualifed.
    if (!!~[APPLICANT_STATUS.QUALIFIED_CANDIDATE,
            APPLICANT_STATUS.QUALIFIED_IN_WAITING,
            APPLICANT_STATUS.QUALIFIED_CANDIDATE_IN_QUEUE].indexOf(value.id)) {
      this.setState({
        confirmationOpen: true,
        newStatus: value,
        oldStatus: _.get(this.props.applicant.profile, 'applicantStatus', null),
      });

      const updatedApplicant = this.props.applicant;
      updatedApplicant.profile.applicantStatus = value;
      this.props.dispatch(syncActionCreators.updateApplicant(updatedApplicant));
    }
    else {
      this.updateApplicantStatus(value);
    }
  }

  onDeletion() {
    this.setState({
      deleteConfirmationOpen: true,
    });
  }

  setDimensions() {
    const collapsedStyle = {};
    let statusTagTransform = '';
    let offScreen = false;
    if(!isServer) {
      const element = document.getElementById(this.props.params.id);

      if(!element) { // handle element off screen case
        offScreen = true;
        statusTagTransform = 'translate3d(calc(-100% - 21px),0,0)'; // initial style
      } else {
        // collapsed card calculations
        const dimCollapsed = getPosition(element);
        const scaleY = dimCollapsed.height/this.state.expandedStyle.height;
        const scaleX = dimCollapsed.width/this.state.expandedStyle.width;
        const translateX = window.innerWidth/2 - dimCollapsed.left + this.state.expandedStyle.width*(1 - scaleX)/2;
        const translateY = window.innerHeight/2 - dimCollapsed.top + this.state.expandedStyle.height*(1 - scaleY)/2;
        collapsedStyle.transform = `translate3d(${-translateX}px, ${-translateY}px,0) scale(${scaleX},${scaleY})`;

        // status flag calculations
        const {width: $textWidth} = getTextSize(this.props.applicant.profile.applicantStatus.name, statusFlagStyles); // textwidth is used to standardize accross different text lengths
        const widthConstant = 260;
        const $scaleDown = 10;
        const $scaleUp = 1.8;
        const $scaleX = 1 / $scaleDown * $scaleUp * widthConstant/$textWidth;
        const $scaleY = 1 * $scaleUp * 76/dimCollapsed.height; // 'dimCollapsed.height' used to adjust based on height of card
        const $endTranslateX = -100;
        const $translateX = $endTranslateX - 100 * $scaleDown / $scaleUp / 2 - 100 * (1.135 - $scaleUp) * widthConstant*2/$textWidth;
        const $endTranslateY = 0;
        const $translateY = $endTranslateY + $scaleDown * 1.5 * 76/dimCollapsed.height; // 'dimCollapsed.height' used to adjust based on height of card
        const $leftPadding = 42;
        statusTagTransform = `scale(${$scaleX}, ${$scaleY}) translate3d(calc(${$translateX}% - ${$leftPadding / 2}px), ${$translateY}%, 0)`;
      }
    }

    const openInWindow = this.props.route.query.openInWindow === '1';

    // worksheet calculations
    const worksheetStyle = this.state.worksheetStyle;

    // step calculations
    const stepsContainerHeight = openInWindow? global.innerHeight : global.innerHeight - 211 - 35; //card height + subnav height

    // notes calculations
    const notesFullWidth = worksheetStyle.alertsContainer.width + worksheetStyle.alertsContainer.marginLeft; // width + margin

    this.setState(_.merge({}, this.state, {
      offScreen,
      collapsedStyle: _.merge(this.state.collapsedStyle, collapsedStyle),
      worksheetStyle: {
        stepsContainer: {
          steps: {
            height: stepsContainerHeight - worksheetStyle.stepsContainer.subnav.height - worksheetStyle.stepsContainer.subnav.marginTop - worksheetStyle.stepsContainer.subnav.marginBottom
          }
        },
        alertsContainer: {
          top: -this.state.expandedStyle.height,
          right: -notesFullWidth
        },
        alertsContainerScaleY: this.state.expandedStyle.height / worksheetStyle.alertsContainer.height,
        stepsContainerScaleY: this.state.expandedStyle.height / stepsContainerHeight,
        cardTranslateX: notesFullWidth/2,
        cardTranslateY: stepsContainerHeight/2,
        closeTranslateX: notesFullWidth,
        detailToggleTranslateY: stepsContainerHeight,
      },
      statusTagTransform
    }));
  }

  stateToggle(prop, state) {


    const updatedQueryString = queryStringify(_.merge({}, this.props.route.query, {
      [prop]: state
    }));

    const route = this.props.route.current;

    // Add the default cateogry and subcategory terms to route.
    if (route.split('/').length === 4) {
      this.props.dispatch(push(`${route}/${this.props.viewOrder[0].key}/${updatedQueryString ? `?${updatedQueryString}` : ''}`));
    }
    else {
      this.props.dispatch(push(`${route}${updatedQueryString ? `?${updatedQueryString}` : ''}`));
    }
  }

  toggleGuide = () => {
    this.setState(_.merge({}, this.state, {guideOpen: !this.state.guideOpen}));
  }

  isPinned(pinnedApplicant) {
    return _.get(this.props.pins, 'pinned.applicants', []).indexOf(pinnedApplicant.profile.id) >= 0;
  }

  togglePin(applicant) {
    let newPinnedData = this.props.pins.pinned;
    if (this.isPinned(applicant)) {
      _.pull(newPinnedData.applicants, applicant.profile.id)
    }
    else {
      _.set(newPinnedData, 'applicants', _.union(_.get(newPinnedData, 'applicants', []), [applicant.profile.id]));
    }

    this.props.dispatch(updatePins(newPinnedData, (err, pins) => {
      if (!err) {
        this.props.dispatch(syncActionCreators.loadPins(pins))}
      }
    ));
  }
  cancelConfirmation = () => {
    const updatedApplicant = this.props.applicant;
    updatedApplicant.profile.applicantStatus = this.state.oldStatus;
    this.props.dispatch(syncActionCreators.updateApplicant(updatedApplicant));

    this.setState({
      confirmationOpen: false,
      newStatus: {},
      oldStatus: {}
    });
  }

  cancelDeleteConfirmation = () => {
    this.setState({
      deleteConfirmationOpen: false,
    });
  }

  continueConfirmation = () => {
    let updatedStatus = this.state.newStatus;
    // Move Qualified  applicant to Qualified in queue if availabilityDate > 45.
    if (updatedStatus.id === APPLICANT_STATUS.QUALIFIED_CANDIDATE &&
        this.props.availabilityDateBetween45DaysAnd4Months) {
      updatedStatus = {
        id: APPLICANT_STATUS.QUALIFIED_CANDIDATE_IN_QUEUE,
        name: 'Qualified Candidate in Queue'
      };
    }

    // Move Qualified applicant to Qualified in waiting if availabilityDate > 4 months.
    else if (updatedStatus.id === APPLICANT_STATUS.QUALIFIED_CANDIDATE && this.props.availabilityDateMoreThan4Months) {
      updatedStatus = {
        id: APPLICANT_STATUS.QUALIFIED_IN_WAITING,
        name: 'Qualified in Waiting'
      };
    }

    this.updateApplicantStatus(updatedStatus);
    this.setState({
      confirmationOpen: false,
      newStatus: {},
      oldStatus: {}
    });
  }

  continueDeleteConfirmation = () => {
    this.props.dispatch(asyncActionCreators.deleteApplicant(this.props.applicant.profile.id, this.props.applicantGroupName));
    this.setState({
      deleteConfirmationOpen: false,
    });
    this.onClose();
  }

  updateApplicantStatus(status) {
    this.props.dispatch(asyncActionCreators.updateApplicantStatus(
      this.props.applicant,
      status,
      this.props.applicantGroupName,
      this.props.arrayIndex
    ));
  }

  updateApplicant(updatedApplicant, callback) {
    const update =  _.merge({}, updatedApplicant, {
        profile: {
          id: this.props.applicant.profile.id
        },
        user: {
          id: this.props.applicant.user.id
        }
      });
    this.props.dispatch(asyncActionCreators.updateApplicantAdmin(
      update,
      this.props.applicantGroupName,
      this.props.arrayIndex,
      (err) => {
        if (err) {
          if (callback) return callback(err);
        }
        this.props.dispatch(syncActionCreators.updateApplicant(update));
        if (callback) return callback(null, update);
      }
    ));
  }

  updateApplicantAssessments(tempState) {
    if (tempState.assessments) {
      this.props.dispatch(asyncActionCreators.updateApplicantAssessments(
        this.props.applicant, tempState.assessments
      ), this.updateTempState('assessments', '', null, {}));
    }
  }

  updateTempState = (parent, prop, event, val, cb) => {
    const newTempState = _.cloneDeep(this.props.tempState);
    const propPath = parent && !prop ? parent : !parent && prop ? prop : `${parent}${prop[0] === '[' ? '' : '.'}${prop}`;

    if(val === undefined) {
      // unsets parent objects if they are empty
      deepUnset(newTempState, propPath);
    } else {
      _.setWith(newTempState, propPath, val, Object);
    }

    this.props.dispatch(
      syncActionCreators.updateTempState(newTempState)
    );

    if(typeof cb === 'function') {
      cb();
    }
  }

  renderCard(editIsOpen, detailIsOpen, scoreIsOpen, documentIsOpen) {
    const followUpTask = _(this.props.applicant.profile.tasks)
                            .filter(task => task.taskFollowUpDate && (new Date(task.taskFollowUpDate) - Date.now() > 0))
                            .sortBy(task => new Date(task.taskFollowUpDate))
                            .head();
    if (editIsOpen) {
      return (
        <div className='expanded-card'>
          <EditView user={this.props.user}
            applicant={this.props.applicant}
            staticData={this.props.staticData}
            stateToggle={::this.stateToggle}
            updateApplicant={::this.updateApplicant}
            dispatch={this.props.dispatch}
            onDeletion={::this.onDeletion}
            open={editIsOpen}/>
        </div>
      );
    }

    else if (scoreIsOpen) {
      return (
        <div className='expanded-card'>
          <AssessmentContainer open={scoreIsOpen} stateToggle={::this.stateToggle}/>
        </div>
      );
    }

    else if (documentIsOpen) {
      return (
        <div className='expanded-card'>
          <DocumentsView applicant={this.props.applicant} staticData={this.props.staticData} stateToggle={::this.stateToggle} open={documentIsOpen}/>
        </div>
      );
    }

    return (
      <div className='expanded-card'>
        <FrontView
          applicant={this.props.applicant}
          user={this.props.user}
          profile={this.props.profile}
          staticData={this.props.staticData}
          statusColor={this.props.statusColor}
          followUpTask={followUpTask}
          stateToggle={::this.stateToggle}
          onStatusChange={::this.onStatusChange}
          style={this.state.expandedStyle}
          toggleGuide={::this.toggleGuide}
          route={this.props.route}/>
      </div>
    );
  }

  renderEvents() {
      const {
        alertsContainer
      } = this.state.worksheetStyle;

      return (
        <Events
          style={alertsContainer}
          applicant={this.props.applicant}
          applicantStatusColor={this.props.statusColor}
          taskTypes={this.props.staticData.applicantTaskTypeList}
          taskResultTypes={this.props.staticData.applicantTaskResultList}
          taskList={this.props.applicant.alertsList}
          route={this.props.route}
        />
      );
  }

  render() {

    // convert string #s to boolean
    const editIsOpen = this.props.route.query.edit === '1';
    const scoreIsOpen = this.props.route.query.edit === '2';
    const documentIsOpen = this.props.route.query.edit === '3';
    const detailIsOpen = !!+this.props.route.query.detail;
    const openInWindow = this.props.route.query.openInWindow === '1';


    const {
      closeTranslateX,
      detailToggleTranslateY,
      stepsContainer,
      alertsContainer,
      cardTranslateX,
      cardTranslateY,
      alertsContainerScaleY,
      stepsContainerScaleY
    } = this.state.worksheetStyle;

    // conditional upon whether or not current card is on screen
    const currentModalProps = this.state.offScreen ? {
      floatDownModalChildren: true,
      transformTransitionOut: 'ease-in-out'
    } : {
      childAnimInit: this.state.collapsedStyle
    };

    return (
      this.props.applicant
      &&
      <div className={cx('applicant-card-container', { openInWindow })}>
        {
          this.state.confirmationOpen
          &&
          <StatusConfirmation
            message={this.state.newStatus.id == 11 && 'Are you sure this applicant is a Qualified Candidate and should be exported to Bullhorn?'}
            cancelFunc={this.cancelConfirmation}
            continueFunc={this.continueConfirmation}
          />
        }
        {
          this.state.deleteConfirmationOpen
          &&
          <StatusConfirmation
            message={'Are you sure want to delete the account?'}
            cancelFunc={this.cancelDeleteConfirmation}
            continueFunc={this.continueDeleteConfirmation}
          />
        }
        <Modal
          show fadeModal fadeModalChildren noScroll outsideUnclickable
          onClose={::this.onClose}
          transitionDuration={400}
          opacityTransitionIn='cubic-bezier(0,1,.2,.8)'
          childStyle={detailIsOpen && {transform: `translate3d(calc(-50% - ${cardTranslateX}px), calc(-50% - ${cardTranslateY}px), 0)`} || {}}
          modalContentClass={cx('expanded-card-container', {'edit-view': editIsOpen, 'score-view': scoreIsOpen, 'document-view': documentIsOpen, 'detail-view': detailIsOpen})}
          {...currentModalProps}
        >

          <div className='modal-actions'>
            <div className='pin' onClick={this.togglePin.bind(this, this.props.applicant)}> <TackIcon /> {this.isPinned(this.props.applicant) ? 'unpin': 'pin'}</div>
          </div>
          {
            // Disable close for window popup.
            !openInWindow
            &&
            <ModalClose removeState={(editIsOpen || detailIsOpen || scoreIsOpen || documentIsOpen) && this.stateToggle.bind(this, editIsOpen || scoreIsOpen || documentIsOpen ? 'edit' : 'detail', 0)}/>
          }
          {
            this.renderCard(editIsOpen, detailIsOpen, scoreIsOpen, documentIsOpen)
          }
          <div className={cx('worksheet')} >
            <SubNav
              dispatch={this.props.dispatch}
              route={this.props.route}
              style={stepsContainer.subnav}
              activeStepIndex={this.state.activeStepIndex}
              onChangeStep={this.onChangeStep.bind(this)}
            />
          {
            this.props.children
            ||
            <Steps style={stepsContainer}
                   applicantGroupName={this.props.applicantGroupName}
                   arrayIndex={this.props.arrayIndex}
                   dispatch={this.props.dispatch}
                   staticData={this.props.staticData}
                   tempState={this.props.tempState}
                   updateApplicant={::this.updateApplicant}
                   updateApplicantStatus={::this.updateApplicantStatus}
                   behavioralAnswers={this.props.behavioralAnswers}
                   workObjectives={this.props.workObjectives}
                   workExperiences={this.props.workExperiences}
                   ratings={this.props.ratings}
                   skills={this.props.skills}
                   licenses={this.props.licenses}
                   designations={this.props.designations}
                   applicant={this.props.applicant}
                   activeStepIndex={this.state.activeStepIndex}
                   assessments={this.props.assessments}
                   toggleGuide={this.toggleGuide}
                   guideOpen={this.state.guideOpen}
                    onChangeStep={this.onChangeStep.bind(this)}
                    route={this.props.route}
                />
           }
          </div>
          <div className='card-events'>
            {
              this.renderEvents()
            }
          </div>
          <div className='detail-toggle outside-card' data-id={`View ${detailIsOpen ? 'Card' : 'Worksheet'}`} onClick={this.stateToggle.bind(this, 'detail', 1)}>
            View <FadeOnChange>{detailIsOpen ? 'Card' : 'Worksheet'}</FadeOnChange>
          </div>
          <style>
            {`
              .modal-show.detail-view .modal-close {
                //transform: translate3d(${closeTranslateX}px, -100%, 0);
              }
              .modal-show.detail-view .detail-toggle {
                //transform: translate3d(0, ${detailToggleTranslateY}px, 0);
              }

              .modal-fade .alerts-container {
                //transform: translate3d(calc(-100% - ${alertsContainer.marginLeft}px), calc(-50% + ${this.state.expandedStyle.height/2}px), 0) scale3d(1,${alertsContainerScaleY},1);
              }
              .modal-fade .steps-container {
                //transform: translate3d(0, calc(-100% + ${this.state.expandedStyle.height/2 + stepsContainer.subnav.marginTop}px), 0) scale3d(1,${stepsContainerScaleY},1);
              }
              .modal-fade .status-flag-container {
                //transform: ${this.state.statusTagTransform}
              }

              ${this.state.offScreen ? `
                .status-flag-container {
                  color: hsla(0,0%,100%,.9) !important;
                }

                .status-flag {
                  border-radius: 0 !important;
                  opacity:
                }
              ` : ''}
            `}
          </style>
        </Modal>
      </div>
      ||
      <div/>
    );
  }
}


// creating separate component as slight hack needed to allow access to animating "closeModal" function in close button
class ModalClose extends Component {
  static propTypes = {
    closeModal: PropTypes.func,
    removeState: PropTypes.any
  }

  constructor() {
    super();
    this.respondToKeyPress = ::this.respondToKeyPress;
  }

  componentDidMount() {
    window.addEventListener('keydown', this.respondToKeyPress);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.respondToKeyPress);
  }

  respondToKeyPress(event) {
    // escape key response
    if(event.keyCode === 27 && this.props.closeModal) {
      // if(this.props.removeState && !event.shiftKey) {
      //   return this.props.removeState();
      // }

      this.props.closeModal();
    }
  }

  render() {
    return (
      <div className='modal-close outside-card' data-id='Close' onClick={this.props.closeModal}>
        Close <CloseX style={{color: '#fff'}}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/index.js